import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DeclaracoesFiscaisService } from '../../../services/declaracoes-fiscais.service';
import { DeclaracoesFiscaisMensais } from '../../../models/declaracoesFiscaisMensais.model';
import { CodigoTributoDeclaracaoMensal } from '../../..//models/enums/codigoTributoDeclaracaoMensal.enum';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { GerarDasRequest } from '../../../models/gerarDasRequest.model';
import { Icones } from '../../../shared/variaveisDeRotas';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'app-detalhes-declaracoes-fiscais',
  templateUrl: './detalhes-declaracoes-fiscais.component.html',
  styleUrls: ['./detalhes-declaracoes-fiscais.component.scss']
})
export class DetalhesDeclaracoesFiscaisComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  declaracao: DeclaracoesFiscaisMensais | null = null;
  private userId: string;
  isLoading = true;

  constructor(private declaracoesFiscaisService: DeclaracoesFiscaisService,
    private jwtHelper: JwtHelper,
    private spinnerService: SpinnerService,
  ) {
    this.userId = this.jwtHelper.getUserIdFromToken();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Detalhes Declarações Fiscais');
    this.iconeChange.emit(Icones.listaAmarelo);
    this.spinnerService.show('Carregando detalhes da declaração...');
    this.declaracoesFiscaisService.declaracaoSelecionada$.subscribe(declaracao => {
      this.declaracao = declaracao;
      this.isLoading = false;
      this.spinnerService.hide();
    });
  }

  formatarDataTransmissao(dataHoraTransmissao: string | null): string {
    if (!dataHoraTransmissao) {
      return 'Data não disponível';
    }

    const ano = dataHoraTransmissao.slice(0, 4);
    const mes = dataHoraTransmissao.slice(4, 6);
    const dia = dataHoraTransmissao.slice(6, 8);
    const hora = dataHoraTransmissao.slice(8, 10);
    const minutos = dataHoraTransmissao.slice(10, 12);

    return `${dia}/${mes}/${ano} ${hora}:${minutos}`;
  }


  formatarDataVencimento(dataVencimento: string | null): string {
    if (!dataVencimento) {
      return 'Vencimento não disponível';
    }

    const ano = dataVencimento.slice(0, 4);
    const mes = dataVencimento.slice(4, 6);
    const dia = dataVencimento.slice(6, 8);

    return `${dia}/${mes}/${ano}`;
  }

  formatarPeriodoApuracao(periodo: string | null): string {
    if (!periodo || periodo.length < 8) return 'Período não disponível';
    const ano = periodo.substring(0, 4);
    const mes = periodo.substring(4, 6);
    const dia = periodo.substring(6, 8);

    return `${dia}/${mes}/${ano}`;
  }


  voltar() {
    window.history.back();
    this.declaracoesFiscaisService.clearDeclaracaoSelecionada();
  }

  baixarPdf(base64: string, tipo: string): void {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${tipo}_${this.declaracao?.declaracaoTransmitida?.idDeclaracao}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  obterDescricaoTributo(codigo: number): string {
    switch (codigo) {
      case CodigoTributoDeclaracaoMensal.IRPJ:
        return 'IRPJ';
      case CodigoTributoDeclaracaoMensal.CSLL:
        return 'CSLL';
      case CodigoTributoDeclaracaoMensal.COFINS:
        return 'COFINS';
      case CodigoTributoDeclaracaoMensal.PIS:
        return 'PIS';
      case CodigoTributoDeclaracaoMensal.INSSCPP:
        return 'INSS/CPP';
      case CodigoTributoDeclaracaoMensal.ICMS:
        return 'ICMS';
      case CodigoTributoDeclaracaoMensal.IPI:
        return 'IPI';
      case CodigoTributoDeclaracaoMensal.ISS:
        return 'ISS';
      default:
        return 'Código Desconhecido';
    }
  }

  obterNumeroDocumentoPorIdDeclaracao(idDeclaracao: string | null): string {
  if (!idDeclaracao || idDeclaracao.length < 3) return '';
  return idDeclaracao.slice(-3);
  }

  obterPeriodoApuracaoPorIdDeclaracao(idDeclaracao: string | null): string {
    if (!idDeclaracao || idDeclaracao.length < 14) return '';
    const ano = idDeclaracao.substring(8, 12);
    const mes = idDeclaracao.substring(12, 14);
    return `${mes}/${ano}`;
  }

  gerarDas(): void {
    if (!this.declaracao || !this.declaracao.declaracaoTransmitida) return;

    const userID = this.userId;
    const periodoApuracao = this.declaracao.declaracaoTransmitida.detalhamentoDarfMaed?.periodoApuracao;
    const dataLimiteAcolhimento = this.declaracao.declaracaoTransmitida.detalhamentoDarfMaed?.dataLimiteAcolhimento;

    if (!periodoApuracao || !dataLimiteAcolhimento) {
      console.error("Período de Apuração ou Data Limite Acolhimento ausente.");
      return;
    }

    const request: GerarDasRequest = {
      UsuarioId: userID,
      PeriodoApuracao: periodoApuracao.slice(0, 6),
      DataConsolidacao: dataLimiteAcolhimento
    };
  
    this.spinnerService.show('Gerando DAS...');
    this.declaracoesFiscaisService.gerarDas(request).subscribe({
      next: (response) => {
        this.spinnerService.hide();
        this.baixarPdf(response.dasBase64, 'das');
      },
      error: (err) => {
        this.spinnerService.hide();
        console.error("Erro ao gerar DAS:", err);
      }
    });
  }
}
